import { UserRolesActionType, UserRolesActions } from './action-types';
import { IUserRolesState } from './types';

// Reducer name for dynamic reducer
export const userRolesReducerName = 'userRolesReducer';
export const userRolesInitialState: IUserRolesState = {
  roles: null,
  hasError: false,
};

// Reducer function
export const userRolesReducer = (
  prev: IUserRolesState = userRolesInitialState,  action: UserRolesActions): IUserRolesState => {
  switch (action.type) {
    case UserRolesActionType.SET_USER_ROLES:
      return {
        ...prev,
        roles: action.payload,
        hasError: false,
      };

    case UserRolesActionType.CLEAR_USER_ROLES:
      return {
        ...prev,
        roles: null,
        hasError: false,
      };

    default:
      return prev;
  }
};
